import logo from "./logo.svg";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  redirect,
  Navigate
} from "react-router-dom";
import { loggedIn } from "./scripts/helper";

import PaymentDetails from "./pages/PaymentDetails";
import Callback from "./pages/callback";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Offices from "./pages/Offices";
import Detail from "./pages/Offices/Detail";
import MemberList from "./pages/Offices/Members";
import MemberManagement from "./pages/Members";
import SingleMember from "./pages/Members/single";
import Roles from "./pages/Role";
import SingleRole from "./pages/Role/single";
import Payments from "./pages/Payments";
import SingleLink from "./pages/Payments/single";
import AddPayment from "./pages/Payments/add";
import HomePage from "./pages/Home";
import Protected from './components/Protected';
import context from './scripts/context'
import { useState } from "react";
import History from "./pages/Payments/history";
import ChangePassword from "./pages/ChagnePassword";
import LinkByPnr from "./pages/Payments/by-pnr";
import SingleLinkPNR from "./pages/Payments/single-by-pnr";
import PosPayment from "./pages/Payments/pos";
import SendToPos from "./pages/Payments/send-to-pos"
import Calculator from "./pages/Calculator";
import RefundIban from "./pages/Payments/refund-iban";
import InquiryIbanPage from "./pages/Payments/inquiryIban";
import RefundConfirmation from "./pages/Payments/Refund-confirm";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(context.getIsLoggedIn())

  context.addListenerIsLoggedIn( (il) => {
    setIsLoggedIn(il)
  })

  return (
    <Router>
        <Routes>
          <Route path="/agent/profile" element={
            <Protected isLoggedIn={isLoggedIn}>
              <Profile />
            </Protected>
          } />
          <Route path="/" element={<HomePage />} />
          <Route path="/:id" element={<PaymentDetails />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/agent" element={ <Navigate to="/agent/login" replace={true} /> } />
          <Route path="/agent/login" element={<Login />} />
          <Route path="/agent/offices" element={
            <Protected isLoggedIn={isLoggedIn}>
              <Offices />
            </Protected>
          } />
          <Route path="/agent/offices/detail" element={         
            <Protected isLoggedIn={isLoggedIn}>
                <Detail/>
            </Protected>
          } />
          <Route path="/agent/offices/detail/members" element={
              <Protected isLoggedIn={isLoggedIn}>
                <MemberList />
              </Protected>
          } />
          <Route path="/agent/users" element={
            <Protected isLoggedIn={isLoggedIn}>
              <MemberManagement />
            </Protected>
          } />
          <Route path="/agent/users/single" element={
            <Protected isLoggedIn={isLoggedIn}>
              <SingleMember />
            </Protected>
          } />
          <Route path="/agent/roles" element={
            <Protected isLoggedIn={isLoggedIn}>
              <Roles/>
            </Protected>
          }/>
          <Route path="/agent/roles/single" element={
            <Protected isLoggedIn={isLoggedIn}>
              <SingleRole />
            </Protected>
          }/>
          <Route path="/agent/calculator" element={
            <Protected isLoggedIn={isLoggedIn}>
              <Calculator />
            </Protected>
          }/>
          <Route path="/agent/payments" element={
            <Protected isLoggedIn={isLoggedIn}>
              <Payments />
            </Protected>
          }/>
          <Route path="/agent/payments/single" element={
            <Protected isLoggedIn={isLoggedIn}>
              <SingleLink />
            </Protected>
          }/>
          <Route path="/agent/payments/by-pnr" element={
            <Protected isLoggedIn={isLoggedIn}>
              <LinkByPnr />
            </Protected>
          }/>
          <Route path="/agent/payments/single-by-pnr" element={
            <Protected isLoggedIn={isLoggedIn}>
              <SingleLinkPNR />
            </Protected>
          }/>
          <Route path="/agent/payments/pos-payment" element={
            <Protected isLoggedIn={isLoggedIn}>
              <PosPayment />
            </Protected>
          }/>
          <Route path="/agent/payments/send-to-pos" element={
            <Protected isLoggedIn={isLoggedIn}>
              <SendToPos />
            </Protected>
          }/>
          <Route path="/agent/payments/history" element={
            <Protected isLoggedIn={isLoggedIn}>
              <History />
            </Protected>
          }/>
          <Route path="/agent/payments/send" element={
            <Protected isLoggedIn={isLoggedIn}>
              <AddPayment />
            </Protected>
          } />
          <Route path="/agent/chpass" element={
            <Protected isLoggedIn={isLoggedIn}>
              <ChangePassword />
            </Protected>
          } />
          <Route path="/agent/payments/refund" element={
            <Protected isLoggedIn={isLoggedIn}>
              <RefundIban />
            </Protected>
          }/>
          <Route path="/agent/payments/iban-inquiry" element={
            <Protected isLoggedIn={isLoggedIn}>
              <InquiryIbanPage />
            </Protected>
          }/>
          <Route path="/agent/payments/refund/confirmation" element={
            <Protected isLoggedIn={isLoggedIn}>
              <RefundConfirmation />
            </Protected>
          }/>
        </Routes>
    </Router>
  );
};

export default App;
